export const biblequotes = [
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    },
    {
        "verse": "Genesis 1:1 ",
        "text": "In the beginning God created the heaven and the earth."
    },
    {
        "verse": "John 3:16 ",
        "text": "For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."
    },
    {
        "verse": "Psalm 23:1 ",
        "text": "The Lord is my shepherd; I shall not want."
    },
    {
        "verse": "Romans 8:28 ",
        "text": "And we know that all things work together for good to them that love God, to them who are the called according to his purpose."
    },
    {
        "verse": "Philippians 4:13 ",
        "text": "I can do all things through Christ which strengtheneth me."
    },
    {
        "verse": "Proverbs 3:5 ",
        "text": "Trust in the LORD with all thine heart; and lean not unto thine own understanding."
    },
    {
        "verse": "Isaiah 41:10 ",
        "text": "Fear thou not; for I am with thee: be not dismayed; for I am thy God: I will strengthen thee; yea, I will help thee; yea, I will uphold thee with the right hand of my righteousness."
    },
    {
        "verse": "Jeremiah 29:11 ",
        "text": "For I know the thoughts that I think toward you, saith the LORD, thoughts of peace, and not of evil, to give you an expected end."
    },
    {
        "verse": "Matthew 28:19 ",
        "text": "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost:"
    },
    {
        "verse": "Hebrews 11:1 ",
        "text": "Now faith is the substance of things hoped for, the evidence of things not seen."
    }
]